import IconProfessional from "../../../../assets/images/icons/professional.svg";
import IconPatient from "../../../../assets/images/icons/patient.svg";
import IconPersonal from "../../../../assets/images/icons/personal.svg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { R_LOGIN } from "../../../../constants/routes";
import { Box, Button, Typography } from "@mui/material";
import RoundedButtonOutlined from "components/Buttons/RoundedButtonOutlined";

const Profile = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const ImgCard = [
    <img src={IconProfessional} alt="professional" />,
    <img src={IconPatient} alt="patient" />,
    <img src={IconPersonal} alt="personal" />,
  ];

  const TitleCard = [
    t("global.professional"),
    t("global.patient"),
    t("global.personal"),
  ];

  const TextCard = [
    t("global.i_will_use_the_platform_at_work"),
    t("global.i_was_referred_by_a_professional"),
    t("global.i_am_an_individual_user_or_i_want_to_play_with_my_child"),
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <Box key={props}>
        <Typography>
          {t("global.select_the_option_that_best_fits_your_profile")}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "center",
          alignItems: "center",
          gap: { xs: 2, sm: 2, md: 2, lg: 3 },
          mt: 1,
        }}
      >
        {TitleCard.map((profile, index) => (
          <Button
            key={`btn-${index}`}
            onClick={() => {
              props.setStep("LoginData");
              props.setSignUpForm({
                ...props.signUpForm,
                profile: t(`global.profile_${profile}`),
              });
            }}
            sx={{
              display: "flex",
              flexDirection: {
                xs: "row",
                sm: "column",
              },
              alignItems: "center",
              width: "100%",
              height: {
                xs: "150px",
                sm: "250px",
              },
              border: "2px solid #b5b5b5",
              boxShadow: "0px 4px 4px 0px #00000040",
              borderRadius: "15px",
              padding: "15px",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "transparent",
                border: "2px solid #662D91",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                width: {
                  xs: "50px",
                  sm: "auto",
                },
              }}
            >
              {ImgCard[index]}
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-evenly",
                alignItems: "center",
                height: "100%",
              }}
            >
              <Typography
                sx={{
                  textTransform: "capitalize",
                  fontWeight: 500,
                  fontSize: "25px",
                  color: "#fd9c17",
                }}
              >
                {profile}
              </Typography>
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#4d4d4d",
                  textTransform: "none",
                }}
              >
                {TextCard[index]}
              </Typography>
            </Box>
          </Button>
        ))}
      </Box>
      <Box sx={{ paddingBottom: "15px", paddingTop: "15px" }}>
        <Typography>
          <b>{t("global.remember")}</b>
          {t(
            "global.registration_is_free_and_upon_registering_you_will_have_7_free_days_to_test_the_platform",
          )}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex ",
          justifyContent: { xs: "center", sm: "start" },
        }}
      >
        <RoundedButtonOutlined
          text={t("global.back_to_login")}
          onClick={() => navigate(R_LOGIN)}
        />
      </Box>
    </Box>
  );
};
export default Profile;
